<app-top-nav-bar></app-top-nav-bar>
<router-outlet></router-outlet>
<app-footer></app-footer>
